<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import InputDefault from '@/components/form/InputDefault.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'InputForm',

  components: {
    InputLeadFormWrapper,
    InputDefault,
  },

  props: {
    ...formDefaultProps,

    modelValue: {
      type: String,
      required: true,
    },

    fieldId: {
      type: String,
      default: ''
    },

    /**
     * フォームの type 属性
     */
    type: {
      type: String as PropType<'text' | 'tel' | 'email' | 'number' | 'password'>,
      default: 'text'
    },

    /**
     * 見出しや説明文のサイズ感（InputLeadFormWrapper へ受け流す）
     */
    size: {
      type: String as PropType<'small' | 'normal' | 'large'>,
      default: 'normal',
    },

    /**
     * inputmode 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Global_attributes/inputmode
     */
    inputmode: {
      type: String as PropType<'search' | 'text' | 'tel' | 'email' | 'none' | 'url' | 'numeric' | 'decimal' | undefined>,
      default: undefined,
    },

    placeholder: {
      type: String,
      default: '',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'off',
    },

    maxlength: {
      type: Number,
      default: undefined,
    },
  },

  emits: ['update:modelValue', 'error', 'blur'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme"
    :size="size"
    @error="$emit('error', $event)">
    <InputDefault
      :id="fieldId ? fieldId : undefined"
      :model-value="modelValue"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :inputmode="inputmode"
      :autocomplete="autocomplete"
      :maxlength="maxlength"
      :has-trim="hasTrim"
      :is-disabled="isDisabled"
      :readonly="readonly"
      :is-error="hasError"
      @update:model-value="$emit('update:modelValue', $event)"
      @blur="$emit('blur')" />
  </InputLeadFormWrapper>
</template>
